export default {"src":"/_next/static/media/logo.e77c2f7a.svg","height":263,"width":1015};